export default function ColorService({ theme }) {
  return {
    getSuccessColor,
    getErrorColor,
    getWarningColor,
    getInfoColor,
  };

  function getSuccessColor() {
    return 'success';
  }

  function getErrorColor() {
    return 'error';
  }

  function getWarningColor() {
    return 'warning';
  }

  function getInfoColor() {
    return 'info';
  }
}
